/**
 * Normalize a string for accent/diacritic-insensitive comparison.
 * - Lowercases
 * - Strips combining marks (é → e, ï → i, ç → c, etc.)
 * - Safe on non-string values (returns "")
 */
export function normalizeText(value) {
  if (value == null) return "";
  return String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}
